import { useContext } from 'react'
import { DesignSystemContext, DesignSystemContextValue } from '../providers/DesignSystemProvider'

export function useDesignSystem(): DesignSystemContextValue {
  const ctx = useContext(DesignSystemContext)
  if (!ctx) {
    throw new Error('useDesignSystem must be used within DesignSystemProvider')
  }
  return ctx
}

/** Alias for mode helpers */
export function useThemeMode() {
  const { mode, toggleMode, setThemeId, themeId } = useDesignSystem()
  return { mode, toggleMode, setThemeId, themeId }
}
